module.exports = "http://cdn.realive.com.ua/src/views/player/help/images/mws2.jpg";